<script>
  import { createEventDispatcher } from "svelte";
  const dispatch = createEventDispatcher();

  export let milkDetails;
  export let schooldays;
  export let isActive;

  const toEuro = new Intl.NumberFormat("de-DE", {
    style: "currency",
    currency: "EUR",
  });
</script>

<div class:active={isActive} class="singleMilkOption active">
  <div class="delMilkOption" on:click={() => dispatch("removed")}>
    <div>✗</div>
  </div>
  <div class="milkOptionContent" on:click={() => dispatch("selected")}>
    <img
      src={`/assets/img/${milkDetails.imgName}.png`}
      alt="Erdbeermilchpackung"
      height="100%"
    />
    <div class="milkOptionInfo">
      <p>{milkDetails.name}</p>
      <p>
        {toEuro.format(milkDetails.pricePerDay * schooldays)}
        <span class="perWeek"> / Woche</span>
      </p>
    </div>
  </div>
</div>

<style>
  .milkOptionContent > img {
    max-width: 85px;
    max-height: 100%;
    width: auto;
    height: auto;
    filter: drop-shadow(3px 8px 8px rgba(0,0,0,0.5));
  }

  .perWeek {
    font-size: 10px;
    font-weight: 500;
  }

  .singleMilkOption.active > .delMilkOption {
    opacity: 1;
    cursor: pointer;
    pointer-events: all;
  }
  .singleMilkOption > .delMilkOption {
    opacity: 0;
    cursor: default;
    pointer-events: none;
    transition: opacity 0.35s ease-in-out, transform 0.1s ease-in-out;

    position: absolute;
    top: -13px;
    right: -13px;
    z-index: 1000;
    width: 30px;
    height: 30px;
    background: #63b4d1;
    border-radius: 50%;
    color: #fff;
  }

  .singleMilkOption > .delMilkOption:hover {
    transform: scale(1.2);
  }

  .delMilkOption > div {
    transform: translateY(3px);
  }

  .singleMilkOption {
    user-select: none;
    border-radius: 10px;
    height: 120px;
    width: 210px;
    margin: 10px 10px;
    box-shadow: 0 0 8px rgba(0, 0, 0, 0.12);
    border: 0 solid #63b4d1;
    transform: scale(1) translateY(1px);
    transition: transform 0.15s ease-in-out, box-shadow 0.25s ease-in-out,
      background 0.1s ease-in-out, border 0.1s ease-in-out,
      color 0.1s ease-in-out;
  }
  .singleMilkOption:hover {
    cursor: pointer;
    transform: scale(1.02);
    box-shadow: 0 0 15px rgba(0, 0, 0, 0.2);
  }

  .singleMilkOption > div.milkOptionContent {
    opacity: 0.75;
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    padding-right: 25px;
    justify-content: space-between;
    align-items: center;
  }
  .singleMilkOption.active > div.milkOptionContent {
    opacity: 1;
  }
  .singleMilkOption > div.milkOptionContent > div.milkOptionInfo > p {
    margin-bottom: 0;
  }
  .singleMilkOption > div.milkOptionContent > div.milkOptionInfo {
    text-align: right;
    line-height: 18px;
    font-size: 15px;
    font-weight: bolder;
  }

  .singleMilkOption.active {
    background: rgba(99, 180, 209, 0.3);
    border: 3px solid #63b4d1;
    color: #215d71;
  }
</style>
